import LocalShipping from '@mui/icons-material/LocalShipping';
import {  NRSList} from './List';
// import {nrsEdit} from './Edit';

const conf = {
    name: 'onpoint_nrs_stores',
    icon: <LocalShipping />,
    list: NRSList,
    // edit: nrsEdit,
    // show: ShowGuesser,
    options: {
        label: "NRS",
        items: true
    }
};

export default conf